import { MediaMatcher } from "@angular/cdk/layout"
import {
  ChangeDetectorRef,
  Component,
  OnDestroy,
  ViewChild
} from "@angular/core"
import { MatSidenav } from "@angular/material/sidenav"

@Component({
    selector: "app-client-layout",
    templateUrl: "./client-layout.component.html",
    styleUrls: ["./client-layout.component.scss"],
    standalone: false
})
export class ClientLayoutComponent implements OnDestroy {
  @ViewChild("sidenav") sidenav!: MatSidenav

  public mobileQuery: MediaQueryList
  private mobileQueryListener: () => void

  constructor(changeDetectorRef: ChangeDetectorRef, media: MediaMatcher) {
    this.mobileQuery = media.matchMedia("(max-width: 1024px)")
    this.mobileQueryListener = () => changeDetectorRef.detectChanges()
    this.mobileQuery.addEventListener("change", this.mobileQueryListener)
    const hidden = localStorage.getItem("hidden") == "1"

    this.isShowSidebar = !hidden && !this.mobileQuery.matches
  }

  private _showSidebar: boolean = true
  public get isShowSidebar() {
    return this._showSidebar
  }

  public set isShowSidebar(value: boolean) {
    this._showSidebar = value
    localStorage.setItem("hidden", `${value ? 0 : 1}`)
  }

  public async ngOnDestroy() {
    this.mobileQuery.removeEventListener("change", this.mobileQueryListener)
    await this.sidenav?.close()
  }
}
